import axios from "@/plugins/axios";
import qs from "qs";
import utils from "@/stores/utils";
import store from "@/stores/store";
import catalogassignments from "./submodules/catalogassignments";
import catalogagentassignments from "./submodules/catalogagentassignments";
import catalogentries from "./submodules/catalogentries";
import $utils from '@/utils';
import { migrateCatalogEntryFormatFilter } from "@/utils/apiFilterParams";
import { executeBulkAction as executeBulk } from "@/utils/bulk";
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';

const { getStorageKey } = utils;

const state = {
    mode: "operator",
    section: null,

    catalog: {},
    catalog_loading: false,
    catalog_loading_errors: null,
    catalog_saving: false,
    catalog_saving_errors: {},
    catalog_archived: false,
    catalog_archived_errors: null,
    catalog_archiving: false,
    catalog_archiving_errors: null,
    catalog_unarchiving: false,
    catalog_unarchiving_errors: null,

    catalogs: [],
    catalogs_count: 0,
    catalogs_loading: false,
    catalogs_loading_errors: null,

    catalogentry: false,
    catalogentry_loading: false,
    catalogentry_loading_errors: null,
    catalogentry_saving: false,
    catalogentry_saving_errors: {},

    products: [],
    products_count: 0,
    products_filters: {},
    products_loaded: false,
    products_loading: false,
    products_loading_error: null,
    products_cancel_source: null,

    selected_catalogentry_items: [],
    bulk_action_loading: false,

    stats: null,
    stats_cancel_source: null,
    catalogs_cancel_source: null,
};

const mutations = {
    updateSection(state, section) {
        state.section = section;
    },
    updateProducts(state, products) {
        state.products = products;
        state.products_loaded = true;
        state.products_loading = false;
        state.products_loading_errors = null;
        state.selected_catalogentry_items = state.selected_catalogentry_items
            .map((s) => products.find((p) => p.id === s.id))
            .filter(Boolean);
    },
    updateProductsCount(state, count) {
        state.products_count = count;
    },
    updateProductsLoaded(state, loaded) {
        state.products_loaded = loaded;
    },
    updateProductsLoading(state, products_loading) {
        state.products_loading = products_loading;
    },
    updateProductsLoadingErrors(state, products_loading_errors) {
        state.products_loading_errors = products_loading_errors;
        state.products_loading = false;
    },
    updateProductsFilters(state, products_filters) {
        state.products_filters = migrateCatalogEntryFormatFilter(products_filters);
        if (!Number.isFinite(state.products_filters.limit)) {
            state.products_filters.limit = 20;
        }
        if (!Number.isFinite(state.products_filters.offset)) {
            state.products_filters.offset = 0;
        }
    },

    updateCatalog(state, catalog) {
        state.catalog = catalog;
        state.catalog_loading = false;
        state.catalog_loading_errors = null;

        if (catalog && state.catalog && state.catalog.id == catalog.id) {
            return;
        }

        state.products = [];
        state.products_count = 0;
        state.products_loaded = false;
        state.products_loading = false;
        state.products_loading_error = null;
        state.products_filters = {
            type: "product",
            offset: 0,
            limit: 20,
            catalog: catalog?.id,
            ordering: "product_name",
            include_all_products: false,
            include_archived: catalog?.archived,
        };
        state.selected_catalogentry_items = [];
    },

    updateCatalogLoading(state) {
        state.catalog_loading = true;
        state.catalog_loading_errors = null;
    },
    updateCatalogLoadingErrors(state, errors) {
        state.catalog_loading = false;
        state.catalog_loading_errors = errors;
    },
    updateCatalogSaving(state, saving) {
        state.catalog_saving = saving;
    },
    updateCatalogSavingErrors(state, errors) {
        state.catalog_saving = false;
        state.catalog_saving_errors = errors || {};
    },
    updateCatalogArchiving(state, archiving) {
        state.catalog_archiving = archiving;
    },
    updateCatalogArchivingErrors(state, errors) {
        state.catalog_archiving_errors = errors;
    },
    updateCatalogUnarchiving(state, unarchiving) {
        state.catalog_unarchiving = unarchiving;
    },
    updateCatalogUnarchivingErrors(state, errors) {
        state.catalog_unarchiving_errors = errors;
    },

    updateCatalogs(state, catalogs) {
        state.catalogs = catalogs;
    },
    updateCatalogsCount(state, count) {
        state.catalogs_count = count;
    },
    updateCatalogsLoading(state, loading) {
        state.catalogs_loading = loading;
    },
    updateCatalogsLoadingErrors(state, errors) {
        state.catalogs_loading_errors = errors;
    },
    updateCatalogsCancelSource(state, cancel_source) {
        state.catalogs_cancel_source = cancel_source;
    },

    updateCatalogEntry(state, catalogentry) {
        state.catalogentry = catalogentry;
    },
    updateCatalogEntryLoading(state, loading) {
        state.catalogentry_loading = loading;
    },
    updateCatalogEntryLoadingErrors(state, errors) {
        state.catalogentry_loading_errors = errors;
    },
    updateCatalogEntrySaving(state, saving) {
        state.catalogentry_saving = saving;
        state.catalogentry_saving_errors = null;
    },
    updateCatalogEntrySavingErrors(state, errors) {
        state.catalogentry_saving = false;
        state.catalogentry_saving_errors = errors;
    },

    updateCatalogProductsSaving(state) {
        state.catalog_products_saving = true;
    },
    updateCatalogProductsSavingErrors(state, errors) {
        state.catalog_products_saving = false;
        state.catalog_products_saving_errors = errors;
    },

    updatePurchasePrice(state, params) {
        if (params.unit_amount == "") {
            params.unit_amount = null;
        }
        // Lookup entry in products and modify in place
        const product = state.products.find((product) => product.id == params.product);
        if (product) {
            if (product.catalogentry_data) {
                product.catalogentry_data.unit_amount = params.unit_amount;
            } else {
                product.catalogentry_data = { unit_amount: params.unit_amount };
            }
        }
    },
    updateProductAgentCommission(state, params) {
        if (params.unit_agent_commission == "") {
            params.unit_agent_commission = null;
        }
        // Lookup entry in products and modify in place
        const product = state.products.find((product) => product.id == params.product);
        if (product) {
            if (product.catalogentry_data) {
                product.catalogentry_data.unit_agent_commission = params.unit_agent_commission;
            } else {
                product.catalogentry_data = { unit_agent_commission: params.unit_agent_commission };
            }
        }
    },

    updateProductForceVatRate(state, params) {
        if (params.vat_rate == "") {
            params.vat_rate = null;
        }
        // Lookup entry in products and modify in place
        const product = state.products.find((product) => product.id == params.product);
        if (product) {
            if (product.catalogentry_data) {
                product.catalogentry_data.vat_rate = params.vat_rate;
            } else {
                product.catalogentry_data = { vat_rate: params.vat_rate };
            }
        }
    },

    updateStats(state, stats) {
        state.stats = stats;
    },
    updateStatsCancelSource(state, cancel_source) {
        state.stats_cancel_source = cancel_source;
    },
    updateProductsCancelSource(state, cancel_source) {
        state.products_cancel_source = cancel_source;
    },

    updateSelectedCatalogEntryItems(state, items) {
        state.selected_catalogentry_items = items;
    },

    updateCatalogBulkActionLoading(state, loading) {
        state.bulk_action_loading = loading;
    },
};

const getters = {

};

const actions = {

    exportProductCatalogEntriesToCSV({ state }, params) {
        let filters = {};
        if (params.filtered) {
            filters = Object.assign({}, state.products_filters);
            filters.offset = null;
        }
        filters.catalog = state.catalog.id;
        filters.format = 'csv';
        filters.type = "product";
        filters.limit = CSV_EXPORT_LIMIT;
        
        const catalogName = state.catalog?.name || '';
        
        $utils.downloadFile({
            url: "/api/productcatalogentries/",
            params: filters,
        }, $utils.getFilename('productCatalogEntries', { catalog_name: catalogName }));
    },


    exportToCSV({ commit, dispatch, state }, params) {
        let filters = {
            ...{
                format: "csv",
                limit: CSV_EXPORT_LIMIT,
                catalog: state.catalog.id,
            },
            ...(params || {}),
        };
        
        const catalogName = state.catalog?.name || '';
        
        $utils.downloadFile({
            url: "/api/catalogentries/",
            params: filters,
        }, $utils.getFilename('catalogEntries', { catalog_name: catalogName }));
    },

    async fetchCatalogStats({ commit, dispatch, state }, params) {
        if (state.stats_cancel_source) {
            state.stats_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateStatsCancelSource", cancelSource);

        try {
            const response = await axios.get(`/api/catalogs/${state.catalog.id}/stats/`, {
                cancelToken: state.stats_cancel_source?.token
            });
            commit("updateStats", response.data);
            commit("updateStatsCancelSource", null);
            return response.data;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit("updateCatalogLoadingErrors", error.details);
            throw error;
        }
    },

    async fetchCatalog({ commit, dispatch, state }, params) {
        commit("updateCatalogLoading", true);
        try {
            let url;
            if (params?.catalog_id) {
                url = `/api/catalogs/${params.catalog_id}/`;
            } else if (state?.catalog) {
                url = `/api/catalogs/${state.catalog.id}/`;
            } else {
                throw "No catalog to fetch";
            }
            const response = await axios.get(url);
            commit("updateCatalogLoading", false);
            commit("updateCatalog", response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogLoadingErrors", error.details);
            throw error;
        }
    },

    async fetchCatalogEntry({ commit, dispatch, state }, params) {
        commit("updateCatalogEntryLoading", true);
        commit("updateCatalogEntryLoadingErrors", null);
        try {
            let url;
            if (params && params.id) {
                url = `/api/catalogentries/${params.id}/`;
            } else if (state.catalog) {
                url = `/api/catalogentries/${state.catalogentry.id}/`;
            } else {
                throw "No catalogentry to fetch";
            }
            const response = await axios.get(url);
            commit("updateCatalogEntryLoading", false);
            commit("updateCatalogEntry", response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogEntryLoading", false);
            commit("updateCatalogEntryLoadingErrors", error.details);
            throw error;
        }
    },

    async setCatalogAsDefault({ commit, dispatch, state }, params) {
        try {
            const url = `/api/catalogs/${state.catalog.id}/default/`;
            const response = await axios.post(url);
            dispatch("fetchCatalog");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async archiveCatalog({ commit, dispatch, state }, params) {
        commit("updateCatalogArchiving", true);
        commit("updateCatalogArchivingErrors", null);
        try {
            const url = `/api/catalogs/${params.instance.id}/archive/`;
            const response = await axios.post(url);
            commit("updateCatalogArchiving", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogArchiving", false);
            commit("updateCatalogArchivingErrors", error.details);
            throw error;
        }
    },

    async unarchiveCatalog({ commit, dispatch, state }, params) {
        commit("updateCatalogUnarchiving", true);
        commit("updateCatalogUnarchivingErrors", null);
        try {
            const url = `/api/catalogs/${params.instance.id}/unarchive/`;
            const response = await axios.post(url);
            commit("updateCatalogUnarchiving", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogUnarchiving", false);
            commit("updateCatalogUnarchivingErrors", error.details);
            throw error;
        }
    },

    async archiveCatalogEntry({ commit, dispatch, state }, params) {
        try {
            await axios.post(`/api/catalogentries/${params.catalogentry.id}/archive/`);
        } finally {
            dispatch("fetchProducts");
        }
    },

    async setProductActive({ commit, dispatch, state }, params) {
        try {
            const url = `/api/catalogentries/${params.catalogentry.id}/active/`;
            const response = await axios.post(url, { active: params.active });
            await dispatch("fetchProducts");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async bulkAction({ commit, dispatch, state }, params) {
        commit("updateCatalogBulkActionLoading", true);
        try {
            const selectedSnapshot = [...state.selected_catalogentry_items];
            const result = await executeBulk({
                bulkActionUrl: "/api/catalogentries/bulk/",
                action: params.action,
                instances: selectedSnapshot.map((item) => item.id),
                items: selectedSnapshot,
                payload: params.payload || {},
                context: params.context,
                getIdFn:
                    params.getIdFn ||
                    ((entry) => {
                        const product = entry.product_data;
                        if (!product) {
                            return String(entry.id);
                        }
                        const name = (product.name || "").trim();
                        const upc = (product.upc || "").trim();
                        if (name && upc) {
                            return `${name} (${upc})`;
                        }
                        return name || upc || String(entry.id);
                    }),
                successMessage: params.successMessage,
            });
            commit("updateSelectedCatalogEntryItems", []);
            await dispatch("fetchProducts");
            return { ...result, items: selectedSnapshot };
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateCatalogBulkActionLoading", false);
        }
    },

    async changeSellPrice({ commit, dispatch, state }, params) {
        try {
            let url = `/api/catalogs/${state.catalog.id}/updateproduct/?a=1`;
            let data = {
                product: params.product,
                catalog: state.catalog.id,
                unit_amount: params.unit_amount,
                vat_rate: params.vat_rate,
                unit_agent_commission: params.unit_agent_commission,
            };
            let method = axios.post;

            const response = await method(url, data);
            commit("updatePurchasePrice", params);
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            dispatch("fetchCatalogStats");
        }
    },

    async setProductAgentCommission({ commit, dispatch, state }, params) {
        try {
            let method = axios.post;
            let url = `/api/catalogs/${state.catalog.id}/updateproduct/?a=2`;
            let data = {
                product: params.product,
                catalog: state.catalog.id,
                unit_amount: params.unit_amount,
                vat_rate: params.vat_rate,
                unit_agent_commission: params.unit_agent_commission,
            };

            const response = await method(url, data);
            commit("updateProductAgentCommission", params);
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async setProductVatRate({ commit, dispatch, state }, params) {
        try {
            let method = axios.post;
            let url = `/api/catalogs/${state.catalog.id}/updateproduct/?a=3`;
            let data = {
                product: params.product,
                catalog: state.catalog.id,
                vat_rate: params.vat_rate,
                unit_amount: params.unit_amount,
                unit_agent_commission: params.unit_agent_commission,
            };

            const response = await method(url, data);
            commit("updateProductForceVatRate", params);
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async setCatalogEntryStatus({ commit, dispatch, state }, params) {
        try {
            const url = `/api/catalogentries/${params.catalogentry.id}/status/`;
            const data = { status: params.status };
            if (params.received_count) {
                data.received_count = params.received_count;
            }
            const response = await axios.put(url, data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async saveCatalog({ commit, dispatch, state }, params) {
        commit("updateCatalogSaving", true);
        commit("updateCatalogSavingErrors", null);
        try {
            let url = "/api/catalogs/";
            let method = axios.post;
            if (params.instance.id) {
                url = `/api/catalogs/${params.instance.id}/`;
                method = axios.put;
            }
            const response = await method(url, params.instance);
            commit("updateCatalogSaving", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogSavingErrors", error.details);
            throw error;
        }
    },

    async fetchCatalogs({ commit, dispatch, state }, params) {
        commit("updateCatalogsLoading", true);
        commit("updateCatalogsLoadingErrors", null);

        if (state.catalogs_cancel_source) {
            state.catalogs_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateCatalogsCancelSource", cancelSource);

        try {
            const response = await axios.get("/api/catalogs/", {
                params: { limit: 1000, include_archived: true },
                cancelToken: state.catalogs_cancel_source?.token
            });
            commit("updateCatalogsLoading", false);
            commit("updateCatalogs", response.data.results);
            commit("updateCatalogsCount", response.data.count);
            commit("updateCatalogsCancelSource", null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit("updateCatalogsLoadingErrors", error.details);
            commit("updateCatalogsLoading", false);
            throw error;
        }
    },



    async fetchProducts({ commit, dispatch, state }, params) {
        if (store.getters["session/current_entity_profile"] != "customer") {
            return;
        }
        commit("updateProductsLoading", true);

        if (state.products_cancel_source) {
            state.products_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateProductsCancelSource", cancelSource);

        try {
            const response = await axios.get("/api/productcatalogentries/", {
                params: migrateCatalogEntryFormatFilter(state.products_filters),
                cancelToken: state.products_cancel_source?.token
            });
            commit("updateProducts", response.data.results);
            commit("updateProductsCount", response.data.count);
            commit("updateProductsCancelSource", null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit("updateProductsLoadingErrors", error.details);
            throw error;
        }
    },

    async save({ commit, dispatch, state }, params) {
        commit("updateCatalogProductsSaving", true);
        try {
            const url = `/api/catalogs/${state.catalog.id}/updateproducts/?a=4`;
            const payload = Object.entries(state.new_data).map(([product, data]) => ({ product: product, ...data }));
            const response = await axios.post(url, payload);
            commit("updateCatalogProductsSaving", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateCatalogProductsSavingErrors", error.details);
            throw error;
        }
    },

    async uploadCatalogPdf({ commit, dispatch, state }, params) {
        let formData = new FormData();
        formData.append('pdf_file', params.pdf_file);

        try {
            const response = await axios.post(
                `/api/catalogs/${state.catalog.id}/pdffile/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            dispatch("fetchCatalog");
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async removeCatalogPdf({ commit, dispatch, state }, params) {
        try {
            const response = await axios.delete(
                `/api/catalogs/${state.catalog.id}/pdffile/`
            );
            dispatch("fetchCatalog");
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async init({ commit, dispatch, state }, params) {
        await commit("updateCatalog", null);
        await commit("updateProducts", []);

        if (!params?.catalog) {
            return;
        }

        if (!params.catalog?.id) {
            commit("updateProductsFilters", {
                type: "product",
                ordering: "product_name",
                include_all_products: false,
            });
            return;
        }
        await commit("updateProductsFilters", {
            catalog: params.catalog.id,
            type: "product",
            ordering: "product_name",
            include_all_products: false,
            include_archived: params.catalog?.archived,
        });
        await dispatch("entries/init", {
            catalog: params.catalog,
            filters: {
                catalog: params.catalog.id,
                ordering: "label",
            },
        });
        await dispatch("services/init", {
            catalog: params.catalog,
            filters: {
                catalog: params.catalog.id,
                type: "service",
                ordering: "label",
            },
        });
        await commit("updateSection", params.section || null);
        await commit("updateCatalog", params.catalog);
        dispatch("fetchCatalogStats");
        await dispatch("session/fetchStats", null, { root: true });

        if (params.catalog.type == "sell") {
            dispatch("agents_assignments/init", {
                catalog: params.catalog,
                filters: {
                    catalog: params.catalog.id,
                },
            });
            dispatch("agents_assignments/fetchCatalogAgentAssignments");

            dispatch("customers_assignments/init", {
                catalog: params.catalog,
                filters: {
                    catalog: params.catalog.id,
                },
            });
            await dispatch("customers_assignments/fetchCatalogAssignments");
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
    modules: {
        customers_assignments: catalogassignments({
            storageKey: getStorageKey('catalog', 'customers_assignments'),
            fieldsToSave: ['limit', 'ordering']
        }),
        agents_assignments: catalogagentassignments({
            storageKey: getStorageKey('catalog', 'agents_assignments'),
            fieldsToSave: ['limit', 'ordering']
        }),
        entries: catalogentries({
            storageKey: getStorageKey('catalog', 'entries'),
            fieldsToSave: ['limit', 'ordering']
        }),
        services: catalogentries({
            storageKey: getStorageKey('catalog', 'services'),
            fieldsToSave: ['limit', 'ordering']
        }),
    },
};
